
export default {
    props: {
        value: {
            type: [String, Number, Boolean],
            default: ""
        },

        name: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            localValue: this.value,
        }
    },
    methods: {
        update() {
            this.$emit('input', this.localValue)
        },
    },
    watch: {
        value(newValue) {
            this.localValue = newValue;
        },
    }
}
